import * as React from "react";
import * as ReactDOM from "react-dom";
/**
 * calculate the height of the element so it extends to the bottom of the window
 * @param $element
 */
function pinToBottom($element: JQuery, $footer?: JQuery, $box?: JQuery) {
    let offset = $element.offset();
    if (offset) {
        let top = offset.top;
        let windowTop = window.scrollY;
        let windowHeight = window.innerHeight;
        let margin = parseInt($element.css('margin-bottom'));
        if (!margin || _.isNaN(margin)) {
            margin = 0;
        }
        let footerHeight = $footer && $footer.length ? $footer.height() : 0;
        let paddingHeight = $box && $box.length ? parseInt($box.css('padding-bottom')) : 0;
        if (_.isNaN(paddingHeight)) {
            paddingHeight = 0;
        }
        if (footerHeight) {
            footerHeight = Math.max(footerHeight, paddingHeight);
            // ignore footer if it is not in view
            const footertop = $footer.offset().top;
            if (footertop > windowHeight + windowTop) {
                footerHeight = 0;
            }
        }
        let minHeight = parseInt($element.css('min-height'));
        if (_.isNaN(minHeight) || !minHeight) {
            minHeight = 0;
        }
        let height = Math.max(windowTop + windowHeight - top - margin - footerHeight, minHeight);

        $element.height(height);
    }
}

export function bind($element: JQuery, $footer: JQuery, $box: JQuery, callback?: Function): EventListener {
    const handler = () => {
        pinToBottom($element, $footer, $box);
        if (callback) {
            callback();
        }
    };

    let listener = _.debounce(() => handler(), 100, false)
    window.addEventListener('resize', listener);
    window.addEventListener('scroll', listener);
    _.defer(handler);
    return listener;
}

export function unbind(listener: EventListener) {
    window.removeEventListener('resize', listener);
    window.removeEventListener('scroll', listener);
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/PinToBottom.ts